import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "d3462f4zRJEX5vZTpl8FSbT", "n_touchMobile", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Node, v3, v2 } from "cc";
import { E_EventType, E_GameMode, E_GameState } from "../EnumBase";
import { App } from "../manager/App";
import n_touch from "./n_touch";
var ccclass = _decorator.ccclass,
    property = _decorator.property;

var n_touchMobile = ccclass(_class = (_temp = /*#__PURE__*/function (_n_touch) {
  _inheritsLoose(n_touchMobile, _n_touch);

  function n_touchMobile() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _n_touch.call.apply(_n_touch, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_id_f", null);

    return _this;
  }

  var _proto = n_touchMobile.prototype;

  // onLoad () {}
  _proto.start = function start() {
    this.node.on(Node.EventType.TOUCH_START, this.touchStart, this);
    this.node.on(Node.EventType.TOUCH_MOVE, this.touchMove, this);
    this.node.on(Node.EventType.TOUCH_END, this.touchEnd, this);
    this.node.on(Node.EventType.TOUCH_CANCEL, this.touchCancel, this);
    this._n_wheelDir.active = false;
    this.addEventListenr();
  };

  _proto.onDestroy = function onDestroy() {
    // GameCtr.I.removeEventListener();
    this.removeEventListener();
  };

  _proto.addEventListenr = function addEventListenr() {
    App.EventMgr.addEventLintener(E_EventType.Touch_BeginSelf, this.handle_beginTouch, this);
    App.EventMgr.addEventLintener(E_EventType.Touch_EndSlef, this.handle_endTouch, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.EventMgr.removeEvent(this);
  };

  _proto.handle_gameEnd = function handle_gameEnd() {
    this._id_f = null;
  };

  _proto.touchStart = function touchStart(e) {
    var curPos = e.getUILocation();

    if (this.isTouchEneable() && this._id_f == null) {
      if (App.GameCtrl.gameMode == E_GameMode.Guide) {// App.EventMgr.handleEvent(E_EventType.Guide_ActorTouchWheel);
      } else {
        this._id_f = e.getID(); // this._pos_touch = e.getUILocation();

        this._n_wheel.setWorldPosition(curPos.x, curPos.y, 0);

        this.handle_beginTouch(e.getUILocation());
      }
    } else if (this._id_f && App.GameCtrl.gameState == E_GameState.Gaming) {}
  };

  _proto.handle_beginTouch = function handle_beginTouch(pos_begin) {
    this._pos_touch = v2(this._n_wheel.worldPosition.x, this._n_wheel.worldPosition.y);
    this._pos_pre = v2(this._pos_touch);

    this._n_wheelCenter.setPosition(v3(0, 0, 0));
  };

  _proto.touchMove = function touchMove(e) {
    if (App.GameCtrl.gameMode == E_GameMode.Guide) return;

    if (this.isTouchEneable() && this._id_f == e.getID()) {}
  };

  _proto.touchEnd = function touchEnd(e) {
    if (App.GameCtrl.gameMode == E_GameMode.Guide) return;

    if (this._id_f == e.getID()) {
      this.handleTouchEnd(e);
    }
  };

  _proto.touchCancel = function touchCancel(e) {
    if (App.GameCtrl.gameMode == E_GameMode.Guide) return;

    if (this._id_f == e.getID()) {
      this.handleTouchEnd(e);
    }
  };

  _proto.handleTouchEnd = function handleTouchEnd(e) {
    if (this.isTouchEneable() && this._id_f != null && App.GameCtrl.gameMode != E_GameMode.Guide) {
      this.handle_endTouch();
    }
  };

  _proto.handle_endTouch = function handle_endTouch() {
    this._id_f = null;
    this._n_wheelDir.active = false;

    this._n_wheel.setPosition(this._posInit_wheel);
  };

  _proto.isTouchEneable = function isTouchEneable() {
    return App.GameCtrl.gameState == E_GameState.Gaming;
  }
  /**
   *  -- 点击使用道具， 移动方向
   */
  ;

  _proto.update = function update(dt) {};

  return n_touchMobile;
}(n_touch), _temp)) || _class;

export { n_touchMobile as default };

_cclegacy._RF.pop();